import { computed } from 'vue';

export const refIsVisible = (refs, name) => {
  const elementInList = refs[name]?.value;
  if (!elementInList) return false;

  let elem = elementInList.$el;

  if (elem.parentElement) elem = elem.parentElement;

  return !!(
    elem.offsetWidth ||
    elem.offsetHeight ||
    elem.getClientRects().length
  );
};

export const computeFormHasValidationErrors = (validation_errors, fields) => {
  return computed(() => {
    return Object.keys(validation_errors).some(
      (key) => validation_errors[key].length > 0 && refIsVisible(fields, key),
    );
  });
};

export const CALCULATOR_TYPE = Object.freeze({
  POWER: '01',
  GAS: '02',
  HEATFLOW: '03',
  DYNAMIC_STROM: '05',
});

export const onSubmitClick = (e, onSubmit) => {
  e.preventDefault();

  onSubmit(e.target.closest('form'));
};

export const onEnterKeyup = (event, onSubmit) => {
  event.preventDefault();
  if (
    event.target.closest('.var-checkbox') ||
    event.target.closest('.var-menu') ||
    event.target.closest('.var-select') ||
    event.target.closest('.suggestion-list')
  )
    return;
  onSubmit(event.target.closest('form'));
};

export const initFromStorage = (formFields, store, props) => {
  let storageData = store.getFormData(
    props.calculatorType,
    props.customerOptions,
  );

  if (storageData !== null) {
    // pauseHouseSizeWatcher.value = true;
    formFields.postcode = storageData.postcode;
    formFields.city = storageData.city;

    if (props.calculatorType === CALCULATOR_TYPE.HEATFLOW) {
      formFields.countingprocedure = storageData.countingprocedure;
      formFields.heatflow_devicetype =
        storageData.heatflow_devicetype === 'false'
          ? false
          : storageData.heatflow_devicetype;
    }

    if (typeof storageData.houseSize !== 'undefined') {
      formFields.houseSize = parseStringToNumber(storageData.houseSize);
    }

    if (typeof storageData.consumption !== 'undefined') {
      formFields.consumption = parseStringToNumber(storageData.consumption);
    }
    if (typeof storageData.consumption_industry !== 'undefined') {
      formFields.consumption_industry = parseStringToNumber(
        storageData.consumption_industry,
      );
    }
    if (typeof storageData.consumption_ht !== 'undefined') {
      formFields.consumption_ht = parseStringToNumber(
        storageData.consumption_ht,
      );
    }
    if (typeof storageData.consumption_nt !== 'undefined') {
      formFields.consumption_nt = parseStringToNumber(
        storageData.consumption_nt,
      );
    }
    if (
      (props.customerOptions === 'b2c_b2b' ||
        props.customerOptions === 'b2b') &&
      storageData.customer === '02'
    ) {
      formFields.customer = '02';
    } else {
      formFields.customer = '01';
    }
    return formFields;
  }
};

export const parseStringToNumber = (string) => {
  return isStringEmptyOrNull(string) ? null : parseInt(string);
};

export const isStringEmptyOrNull = (string) => {
  return string === null || string === '';
};
